/*
- MAYOREO30 (30 prendas minimo) MAYOREO30
- MAYOREO50 (50 prendas minimo) MAYOREO50
- MAYOREO100 (100 prendas minimo) MAYOREO100
- MAYOREO200 (200 prendas minimo) MAYOREO200
*/
export const ftMostrarPrecioNormalMayoreo = ({ cuponAplicado, producto }) => {
    // Validar que el producto y precio existan
    if (!producto || !producto.precio) {
        return 0;
    }

    if (!cuponAplicado) return producto.precio;

    if (cuponAplicado === "MAYOREO30" || cuponAplicado === "TORZOLOVER") {
        const discountPrice = Number(producto.discountOne);
        return discountPrice === 0 || isNaN(discountPrice)
            ? producto.precio
            : discountPrice;
    } else if (cuponAplicado === "MAYOREO50" || cuponAplicado === "TORZOQUEEN") {
        const discountPrice = Number(producto.discountTwo);
        return discountPrice === 0 || isNaN(discountPrice)
            ? producto.precio
            : discountPrice;
    } else if (cuponAplicado === "MAYOREO100" || cuponAplicado === "TORZOKING") {
        const discountPrice = Number(producto.discountThree);
        return discountPrice === 0 || isNaN(discountPrice)
            ? producto.precio
            : discountPrice;
    } else if (cuponAplicado === "MAYOREO200" || cuponAplicado === "TORZOSUPRIME") {
        const discountPrice = Number(producto.discountFour);
        return discountPrice === 0 || isNaN(discountPrice)
            ? producto.precio
            : discountPrice;
    }

    return producto.precio;
};
